import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04360e86"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fields-note" }, [
  /*#__PURE__*/_createTextVNode(" Fields with "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-indicator" }, "*"),
  /*#__PURE__*/_createTextVNode(" are required ")
], -1))

import { ref, getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import NrModal from '@nextrequestco/components/src/components/NrModal/nr-modal.vue'
import {
  CheckboxFieldValue,
  RequestFieldValue,
  TextFieldValue,
  RadioFieldValue
} from 'src/pages/request_show/store/request_state_declarations'
import RequestFieldInput from '../../../vue_shared/components/RequestFieldInput.vue'

interface RequestFieldEditModalProps {
  field: RequestFieldValue
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RequestFieldEditModal',
  props: {
    field: {}
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const store = useStore()
const instance = getCurrentInstance()
const globalProperties = instance?.appContext.config.globalProperties

const fieldValue = ref<TextFieldValue | CheckboxFieldValue | RadioFieldValue>(
  props.field?.value
)
const updating = ref(false)

const handleClose = () => {
  emit('close')
}

const handleSave = async () => {
  if (!props.field) return

  try {
    updating.value = true
    const requestId = store.state.request_show.request.pretty_id

    if (props.field.id) {
      await store.dispatch('request_show/updateFieldValue', {
        id: props.field.id,
        value: fieldValue.value,
        requestId
      })
      globalProperties?.$toasted.success('Successfully updated field value.')
    } else {
      await store.dispatch('request_show/createFieldValue', {
        requestFieldVersionId: props.field.request_field_version.id,
        value: fieldValue.value,
        requestId
      })
      globalProperties?.$toasted.success('Successfully added field value.')
    }

    await store.dispatch('request_show/fetchRequest', requestId)
    handleClose()
  } catch (error) {
    handleError(error)
  } finally {
    updating.value = false
  }
}

const handleError = (error: unknown) => {
  let errorMessage =
    'There has been an error saving the field value. Please refresh the page and try again.'
  if (error instanceof Error) {
    errorMessage = `Error saving field value: ${error.message}`
  }
  globalProperties?.$toasted.error(errorMessage)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(NrModal, {
    show: true,
    title: props.field.id ? 'Edit field' : 'Add field value',
    primaryButtonText: "Continue",
    secondaryButtonText: "Cancel",
    hasSecondaryButton: true,
    disableButtons: updating.value,
    onOnPrimaryClick: handleSave,
    onOnSecondaryClick: handleClose,
    onOnCloseClick: handleClose
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(RequestFieldInput, {
        definition: {
        field_type: props.field.field_type,
        type_settings: props.field.type_settings
      },
        modelValue: fieldValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (fieldValue.value = $event))
      }, null, 8, ["definition", "modelValue"])
    ]),
    _: 1
  }, 8, ["title", "disableButtons"]))
}
}

})